import {Device, Service} from '../Account/PromoCode/PromoCodeRepository';
import {PromoCode} from './PromoCode';

export type ValidatePromoCodeProps = {
  promocode: string;
  device: Device;
  service: Service;
};

export interface PromoRepository {
  applyPromoCode({promocode, device, service}: ValidatePromoCodeProps): Promise<PromoCode>;
  removePromoCode(): Promise<void>;
}
